import { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import {  Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import './XDocList';
import QRCode from 'react-qr-code';

const ClubAccess = ({ memberEmail, memberName, onSendToParent }) => {
  const db = getFirestore();
  const [isLogging, setIsLogging] = useState(false);

  const handleAction = async () => {
    if (isLogging) return;
    setIsLogging(true);
    const ts = new Date();
    try {
      await addDoc(collection(db, "license_logs"), {
        fullName: memberName,
        entryType: "Member",
        method: "ClubAccess",
        // Force rawPayload to be the email for the Index
        rawPayload: memberEmail.toLowerCase(),
        signedInBy: "",
        isExpired: false,
        scannedAt: ts,
      });

   
      onSendToParent(true)
    } catch (e) {
      toast.error("Log failed");
    } finally {
      setIsLogging(false);
    }
  };

  return (
   

      <Button onClick={handleAction}>
        <QRCode value={memberEmail} size={50} className="hoverX" bgColor="transparent" fgColor={"#757575"} level="M" />
        <br></br>
        <span className="">Club Access</span>
      </Button>
   
  );
};

export default ClubAccess;